import styled from "styled-components";

export const EditContainer = styled.div`
	display: flex;
    position: relative;
    opacity: 0;
    visibility: hidden;
    transition-duration: .2s;
`;